module.exports = __webpack_public_path__ + "static/section_2bg-2a0dad4597fe6925e24bd6750b1b0a89.png";